// Module
var code = `<select class="compliance-non-commensurate-select"
        ng-model="\$ctrl.config"
        ng-change="\$ctrl.valueChanged()"
        ng-disabled="\$ctrl.\$attrs.disabled"
        ng-required="\$ctrl.\$attrs.required"
        ng-options="c.id as \$ctrl.formatLabel(c) for c in \$ctrl.configs"
></select>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/administration/compliance/non-commensurate/compliance-non-commensurate-select.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;